import React from 'react';
import MaximizableView from '../../MaximizableView';

import MapView from './mapView';
import MapSettings from './map_settings';

export default class Map extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      orderValue: 'Total-Confirmed-AV',
    };
    this.handleSettings = this.handleSettings.bind(this);
  }

  handleSettings(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const {
      geoCountries, geoMarkers, orderValue,
    } = this.state;
    const params = orderValue.split('-');
    const [period, param, quality] = params;
    return (
      <MaximizableView>
        <MapView
          geoCountries={geoCountries}
          geoMarkers={geoMarkers}
          period={period}
          param={param}
          quality={quality}
        />
        <MapSettings handleChange={this.handleSettings} />
      </MaximizableView>
    );
  }
}
